export type ClipSourceStatus = 'ready' | 'preparing' | 'failed' | 'expired';

export function resolveClipSourceStatus(status: string | null | undefined): ClipSourceStatus {
  if (status == null || status === 'ready') return 'ready';
  if (status === 'failed' || status === 'expired') return status;
  return 'preparing';
}

export function shouldPollClipSource(status: ClipSourceStatus): boolean {
  return status === 'preparing';
}
